// gridContextMenu.js
export function setupGridContextMenu(grid, onDataChange) {
  grid.addEventListener("contextmenu", function (e) {
    console.log("contextmenu", e);
    e.items.push(
      {
        title: `Delete row ${e.cell.viewRowIndex + 1}`,
        click: () => {
          if (e.cell && typeof e.cell.rowIndex === "number") {
            // Get the actual data item to delete (works with sorting)
            const itemToDelete = grid.viewData[e.cell.rowIndex];
            // Remove this specific item from the data
            const updatedData = grid.data.filter(item => item !== itemToDelete);
            grid.data = updatedData;
            onDataChange(updatedData);
          }
        },
      },
      {
        title: "Delete Selected Rows",
        click: () => {
          const selectedRows = grid.selectedRows;
          if (selectedRows && selectedRows.length > 1) {
            // Get the actual data items that are selected
            const selectedItems = Object.keys(selectedRows).map(
              visualIndex => grid.viewData[parseInt(visualIndex)]
            );
            
            // Filter out the selected items
            const updatedData = grid.data.filter(
              item => !selectedItems.includes(item)
            );
            
            grid.data = updatedData;
            onDataChange(updatedData);
          }
        },
      }
    );
  });
}
